/*
 * Mobile - PDP - Details Accordion  --  variant: Accordion Structure - Closed By Default
 * Moonshot experiment id: 24022237   status in Moonshot on 2026-08-27: DEPLOYED   started: 2026-05-21
 * Audience: MOBILE   Target: pdp   (see MGExp.targets in mg-exp-runtime.js)
 * Source: verbatim variant code from cdn.moonshot-ai.com/snippets/36780565.js (prettified);
 *         only change is window.msaiTools._msaiRunVariantBlock -> MGExp.runVariantBlock.
 * Enabled by theme setting: mgexp_pdp_m_details_accordion
 */
MGExp.run('pdp_m_details_accordion', { name: "Mobile - PDP - Details Accordion / Accordion Structure - Closed By Default", platform: 'mobile', target: 'pdp' }, function () {
  !(function () {
    let t = [],
      n = [];
    !(async function (e, i, a, o, s) {
      let c = {
        multi_target_selectors: t,
        page_identifier_selector: "section.prod-page",
        exclude_from_timeout: n,
        selector_timeout: 5e3,
      };
      await MGExp.runVariantBlock(e, i, a, o, s, c);
    })(
      [
        ".pt-3[x-data]",
        ".pt-3[x-data] nav",
        ".pt-3[x-data] .mt-6",
        ".pt-3[x-data] .block",
        "#tab_condition",
        "#tab_description",
        "#tab_sizing",
        "#tab_ship_returns",
        ".pt-3[x-data] [x-show*=\"'condition'\"]",
        ".pt-3[x-data] [x-show*=\"'description'\"]",
        ".pt-3[x-data] [x-show*=\"'sizing'\"]",
        ".pt-3[x-data] [x-show*=\"'ship_returns'\"]",
      ],
      ".msai-accordion-closed-applied",
      function (t, n) {
        const [e, i, a, o, s, c, l, r, m, d, p, u] = n,
          h = [m, d, p, u],
          x = [s, c, l, r].map((t, n) => {
            const e = (t.getAttribute("@click") || "").match(
              /tab\s*=\s*'([^']+)'/,
            );
            return {
              key: e ? e[1] : "tab_" + n,
              label: t.textContent.trim().replace(/\s+/g, " "),
              panel: h[n],
            };
          });
        (x.forEach((t) => {
          t.content = t.panel.innerHTML;
        }),
          (i.style.display = "none"),
          (a.style.display = "none"),
          x.forEach((t) => {
            const n = document.createElement("div");
            n.className = "msai-multi-acc-item";
            const e = document.createElement("button");
            ((e.type = "button"),
              (e.className = "msai-multi-acc-header"),
              (e.innerHTML = `<span>${t.label}</span><svg class="msai-multi-acc-chevron" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M4 6L8 10L12 6" stroke="#000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`));
            const i = document.createElement("div");
            ((i.className = "msai-multi-acc-body"),
              (i.innerHTML = `<div class="msai-multi-acc-inner">${t.content}</div>`),
              e.addEventListener("click", (t) => {
                t.stopPropagation();
                const n = i.classList.contains("msai-open");
                (o
                  .querySelectorAll(".msai-multi-acc-body")
                  .forEach((t) => t.classList.remove("msai-open")),
                  o
                    .querySelectorAll(".msai-multi-acc-chevron")
                    .forEach((t) => t.classList.remove("msai-open")),
                  n ||
                    (i.classList.add("msai-open"),
                    e
                      .querySelector(".msai-multi-acc-chevron")
                      .classList.add("msai-open")));
              }),
              n.appendChild(e),
              n.appendChild(i),
              o.appendChild(n));
          }),
          e.classList.add("msai-accordion-closed-applied"));
      },
      "\n    .msai-multi-acc-item { border-bottom: 1px solid #e5e5e5; }\n    .msai-multi-acc-item:first-child { border-top: 1px solid #e5e5e5; }\n    .msai-multi-acc-header {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        width: 100%;\n        padding: 14px 0;\n        background: none;\n        border: none;\n        font-size: 14px;\n        font-weight: 600;\n        color: #000;\n        cursor: pointer;\n        text-align: left;\n        line-height: 1.4;\n        font-family: inherit;\n        outline: none;\n    }\n    .msai-multi-acc-chevron {\n        transition: transform 0.25s ease;\n        flex-shrink: 0;\n        margin-left: 12px;\n    }\n    .msai-multi-acc-chevron.msai-open { transform: rotate(180deg); }\n    .msai-multi-acc-body {\n        max-height: 0;\n        overflow: hidden;\n        transition: max-height 0.35s ease;\n    }\n    .msai-multi-acc-body.msai-open {\n        max-height: 1000px;\n        padding-bottom: 16px;\n    }\n    .msai-multi-acc-inner { font-size: 14px; color: #000; line-height: 1.6; } \n    .msai-multi-acc-item button:focus {\n        outline: none !important;\n    }\n    .msai-multi-acc-inner .block.md\\:hidden {\n        display: flex !important;\n        margin-top: -20px !important;\n    }\n",
    );
  })();
});
